import PageAnchorList from './PageAnchorList';

export default PageAnchorList;
